Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkedInClassNames = exports.handleLinkedInLoad = void 0;
var _utils = require("../../utils");
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
var isLinkedInScriptAdded = false;
var linkedInClassNames = [".LI-profile-badge", ".LI-simple-link"].join(",");
exports.linkedInClassNames = linkedInClassNames;
var linkedInBadgesUrl = "https://platform.linkedin.com/badges/js/profile.js";
var LIRenderAll = function LIRenderAll() {
  if (_typeof(window.LI) !== "undefined" && _typeof(window.LIRenderAll) === "function") {
    window.LIRenderAll();
  }
};
var handleLinkedInLoad = function handleLinkedInLoad() {
  if (document.querySelector(linkedInClassNames) !== null) {
    if (!isLinkedInScriptAdded) {
      (0, _utils.createScriptTag)(linkedInBadgesUrl, null);
      isLinkedInScriptAdded = true;
      return {
        status: 'createScriptTag'
      };
    }
  }
  LIRenderAll();
  return {
    status: 'null'
  };
};
exports.handleLinkedInLoad = handleLinkedInLoad;